
export class BankConfirmationResult {
  continuePurchase: boolean;
  updatedName: string;

  constructor(continuePurchase: boolean, updatedName: string) {
    this.continuePurchase = continuePurchase;
    this.updatedName = updatedName;
  }
}